import { render, staticRenderFns } from "./addMember.vue?vue&type=template&id=68dae24d&scoped=true&"
import script from "./addMember.vue?vue&type=script&lang=js&"
export * from "./addMember.vue?vue&type=script&lang=js&"
import style0 from "./addMember.vue?vue&type=style&index=0&id=68dae24d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dae24d",
  null
  
)

export default component.exports